import React, { useMemo } from "react";
import { useDataWithRoute } from "../utils/hooks";
import { useVsiAppContext } from "../stores/VsiApp";
import TreeMap from "../components/TreeMap";
import { VsiBubble } from "../styled/App.styled";
import themeStyles, { vsiGreen } from "../utils/themeStyles";
import { Spinner } from "reactstrap";

const determineColor = val => {
  const newVal = val * 100;
  if (newVal >= 5) {
    return "#e10000";
  } else if (newVal >= 0 && newVal < 5) {
    return "grey";
  } else {
    return vsiGreen;
  }
};

const formatTreeData = data => {
  const resourcesDict = {};

  const allVms = data.map((datum, index) => {
    if (!resourcesDict[datum.resource_group]) {
      resourcesDict[datum.resource_group] = `id_${datum.resource_group}_${index}`;
    }

    return {
      id: `id_${datum.resource_name}_${index}`,
      name: `${datum.resource_name}`,
      value: parseFloat(datum.total_cost.toFixed(2)),
      color: determineColor(datum.growth),
      parent: resourcesDict[datum.resource_group]
    };
  });

  const allResources = Object.keys(resourcesDict).map(key => {
    return {
      name: key,
      id: resourcesDict[key]
    };
  });
  return [...allResources, ...allVms];
};

export default function CloudGrowthOverview() {
  const { theme, client: { clientId }, getPeriodId } = useVsiAppContext();

  const periodId = useMemo(() => getPeriodId("CLOUD"), [getPeriodId]);

  const route = useMemo(() => `/api/v6/report/enterprise_cloud_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId]);

  const [{ recordset }, { isLoading }] = useDataWithRoute(route);

  const { treeData, totalCost } = useMemo(() => {
    return {
      treeData: formatTreeData(recordset),
      totalCost: recordset.reduce((accum, val) => accum + val.total_cost, 0).toFixed(2)
    };
  }, [recordset]);

  const series = useMemo(() => {
    return [{
        levels: [{
          level: 1,
          borderWidth: 5,
          dataLabels: {
            enabled: true,
            align: "left",
            verticalAlign: "top",
            color: themeStyles?.[theme]?.textColor,
            style: {
              color: "#FFFFFF",
              fontWeight: "bold",
              fontSize: "1.3rem"
            }
          }
        }, {
          level: 2,
          layoutAlgorithm: "squarified",

          dataLabels: {
            enabled: true,
            align: "center",
            verticalAlign: "middle",
            color: themeStyles?.[theme]?.textColor,
            fontSize: "3rem",
            style: {
              color: "#FFFFFF",
              fontWeight: "bold",
              fontSize: ".9rem"
            }
          }
        }],
        data: treeData
      }]
  }, [theme, treeData]);

  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <VsiBubble>
      <TreeMap series={series}
               title={totalCost ? `Total Cost: $${totalCost}` : null}
               height={400}
      />
    </VsiBubble>
  );
}
